import Event from '../../core/Event';

export default class OrderImportFailed extends Event {
    public static type = 'OrderImportFailed';

    constructor(public readonly errors: string[]) {
        super(OrderImportFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderImportFailed.ts